"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixLinebreaks = fixLinebreaks;
exports.tokenize = tokenize;
function fixLinebreaks(tex) {
    const tokens = tokenize(tex);
    let depth = 0;
    let needsAlignedEnvironment = false;
    const withAllTopLevelNewlinesAligned = tokens
        .map((t) => {
        if (t.startsWith("\\begin") || t === "{") {
            depth++;
            return t;
        }
        if (t.startsWith("\\end") || t === "}") {
            depth--;
            if (depth < 0) {
                depth = 0;
            }
            return t;
        }
        if (depth === 0 && t.includes("\\\\")) {
            needsAlignedEnvironment = true;
            return t.replace(/\\\\(?:\s*\\\\)*(\[[^\]]*])?/g, "\\\\$1&");
        }
        return t;
    })
        .join("");
    if (needsAlignedEnvironment) {
        return ("\\begin{aligned}&" +
            withAllTopLevelNewlinesAligned +
            "\n\\end{aligned}");
    }
    return withAllTopLevelNewlinesAligned;
}
const environmentDelimiter = "\\\\(?:begin|end)\\{[^}]+}";
const linebreaks = "(?:\\\\\\\\\\s*)+(?:\\[[^\\]]*])?";
const escapedCurlyBrace = "\\\\\\{|\\\\}";
const tokens = new RegExp(`(${environmentDelimiter}|${linebreaks}|${escapedCurlyBrace}|[{}])`);
// Exported for testing.
function tokenize(tex) {
    // putting capture group parens around this regex pattern causes `split`
    // to include the capture group contents in the resulting array. Documented
    // here:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/split
    return tex.split(tokens);
}
